// Formatting for date-only values.
//
// Postgres DATE columns (jobs.completed_date, gis_jobs.scheduled_date, …) carry a
// calendar day with no time and no zone. The server runs in UTC, so node-postgres
// hands them back as UTC midnight and the API serializes "2026-08-31T00:00:00.000Z".
// Passing that to `new Date(...)` and formatting it renders the *previous* day for
// anyone west of UTC — a Mountain-time browser shows 8/30 for a job dated 8/31.
//
// Reading the Y/M/D off the string and rebuilding the date locally keeps the calendar
// day the server stored, whatever zone the viewer is in.
//
// Only for date-only columns. Real timestamps (created_at, done_at, event_date, and
// anything else TIMESTAMPTZ) are true instants and SHOULD be zone-converted — use
// plain `new Date(value)` for those.
export function fmtDate(d, fallback = '—') {
  if (!d) return fallback;
  const [y, m, day] = String(d).slice(0, 10).split('-').map(Number);
  if (!y || !m || !day) return fallback;
  return new Date(y, m - 1, day).toLocaleDateString();
}
